import { render, staticRenderFns } from "./UnitsTable.vue?vue&type=template&id=ca693e1a&"
import script from "./UnitsTable.vue?vue&type=script&lang=js&"
export * from "./UnitsTable.vue?vue&type=script&lang=js&"
import style0 from "./UnitsTable.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
